import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface gerarRelatorioRecepcaoObjectProps {
  IdPdv: string | undefined | null;
  DataInicio: string;
  DataFim: string;
}

export interface gerarRelatorioRecepcaoProps {
  params: string;
}

export function useGerarRelatorioRecepcao(
  props: gerarRelatorioRecepcaoProps & QueryGlobalInterface
) {
  const fetchData = async () => {
    const GERAR_RELATORIO_RECEPCAO = `${leadsWebEnviroment}/app-web/atendimentos/relatorio-recepcao/v1${props?.params}`;

    try {
      const response = await instance.get(GERAR_RELATORIO_RECEPCAO, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `relatorio-recepcao-${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error: any) {
      if (error.response?.data instanceof Blob) {
        const errorText = await error.response.data.text();
        try {
          const errorJson = JSON.parse(errorText);
          const customError = new Error("Request failed with status code 400");
          (customError as any).response = {
            ...error.response,
            data: errorJson,
          };
          throw customError;
        } catch (parseError: any) {
          if (parseError.message === "Request failed with status code 400") {
            throw parseError;
          }
          throw error;
        }
      }
      throw error;
    }
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: false,
    onError: (error: any) => {
      const notifications = error?.response?.data?.notifications;
      const errorMessages = Array.isArray(notifications)
        ? notifications.map((item: any) => `\n${item?.message}\n`)
        : ["\nErro desconhecido ao gerar relatório de recepção\n"];

      toast.warning(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
